import { formatNaira } from '../../../../utils/money';
import { formatLagos } from '../../../../utils/datetime';
import { StatusPill } from '../../../ui';
import StoreCell from './StoreCell';

const storeColumn = {
  key: 'store',
  header: 'Store',
  render: (row) => <StoreCell store={row.store} />,
};

// Dashboard and list rows share one shape with Lagos wall-clock times, even on the UTC dashboard; enterprise rows add `store`.
const tapTransactionColumns = ({ dateFilter, statusFilter, showPan = false, showStore = false } = {}) => [
  {
    key: 'created_at',
    header: 'Date (WAT)',
    sortKey: 'created_at',
    sortDefault: 'desc',
    filter: dateFilter,
    render: (row) => <span className="whitespace-nowrap">{formatLagos(row.created_at)}</span>,
  },
  { key: 'reference', header: 'Reference', className: 'whitespace-nowrap', render: (row) => row.reference || '—' },
  ...(showStore ? [storeColumn] : []),
  ...(showPan ? [{ key: 'merchant_pan', header: 'PAN', render: (row) => row.merchant_pan || '—' }] : []),
  { key: 'payer', header: 'Payer', render: (row) => row.payer || '—' },
  { key: 'gross_amount', header: 'Gross', align: 'right', render: (row) => formatNaira(row.gross_amount) },
  { key: 'discount_amount', header: 'Discount', align: 'right', render: (row) => formatNaira(row.discount_amount) },
  {
    key: 'amount',
    header: 'Amount',
    align: 'right',
    sortKey: 'amount',
    sortDefault: 'desc',
    render: (row) => formatNaira(row.amount),
  },
  {
    key: 'status',
    header: 'Status',
    sortKey: 'status',
    filter: statusFilter,
    render: (row) => <StatusPill status={row.status} />,
  },
];

export default tapTransactionColumns;
